import {
  useGetAnnotations,
  useGetDataQuery,
} from "@/utils/react-query-hooks/getData";
import { useMemo } from "react";
import { prepareAnnoBargraphData } from "./prepareAnnoBargraphData";
import { getAnnoExplorerConfigsForThisTenant } from "./getAnnoExplorerConfigsForThisTenant";
import { gtdc_usePrepareThemeUpdatedBargraphData } from "../../../../Plugins/gtdc_usePrepareThemeUpdatedBargraphData";
import { getPluginConfigsForTenant } from "@/Plugins/_EXPORTS";

export const useAnnotationBarGraphData = (
  shouldFetch,
  activeFilters,
  selectedTPLsArrayOptions
) => {
  const annoExplorerConfigs = getAnnoExplorerConfigsForThisTenant();

  const defaultResult = {
    data: [],
    status: "idle",
    error: null,
    isLoading: false,
  };

  if (!shouldFetch) {
    return defaultResult;
  }

  const {
    data: annoData,
    status: dataFetchStatusGraphData,
    error: barGraphError,
    isLoading: barGraphLoading,
  } = useGetAnnotations({
    activeFilters: [
      ...[
        {
          filterId: "contentTypeFilter_contentType",
          values: selectedTPLsArrayOptions,
          target: {
            filterType: "valuePathType",
            valuePath: "meta.contentType",
          },
        },
      ],
      ...activeFilters,
    ],
    dataSource: "annotations",
    projection: {
      tags: 1,
      "annotations.tags": 1,
    },
  });

  let reshapedData;

  //--- this is temp. later we will have this integrated in a scalable format
  const useDoNothing = () => ({});

  const usePluginHook = getPluginConfigsForTenant()?.annotationExplorer_dataViz
  ?.gtdc_usePrepareThemeUpdatedBargraphData;

  const useReshapePlugin = usePluginHook || useDoNothing;

  reshapedData = useReshapePlugin({
    annotations: annoData?.data,
  });

  if (!usePluginHook) {
    reshapedData = prepareAnnoBargraphData(annoData?.data);
  }
  //------- this is temp.

  return {
    data: reshapedData,
    status: dataFetchStatusGraphData,
    error: barGraphError,
    isLoading: barGraphLoading,
  };
};
